import { render, staticRenderFns } from "./el-cascader.vue?vue&type=template&id=2107664a&scoped=true"
import script from "./el-cascader.vue?vue&type=script&lang=js"
export * from "./el-cascader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2107664a",
  null
  
)

export default component.exports